'use strict';

/**
 * HTMLタグの除去
 * @param {string} str
 * @return {string}
 */
export function removeHtmlTag(str) {
  return String(str).replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
}

/**
 * 全額英数を半角英数に変換
 * @param {string} str
 * @return {string}
 */
export function convertFullWidthToHalfWidth(str) {
  return String(str).replace(/[Ａ-Ｚａ-ｚ０-９]/g, e => {
    return String.fromCharCode(e.charCodeAt(0) - 0xFEE0);
  });
}

/**
 * キャメルケースへ変換 sampleString
 * @param string
 * @return string
 */
export function toCamelCase(str){
  str = str.charAt(0).toLowerCase() + str.slice(1);
  return str.replace(/[-_](.)/g, function(match, group1) {
    return group1.toUpperCase();
  });
}


/**
 * スネークケースへ変換 sample_string
 * @param string
 * @return string
 */
export function toSnakeCase(str){
  var camel = toCamelCase(str);
  return camel.replace(/[A-Z]/g, function(s){
    return "_" + s.charAt(0).toLowerCase();
  });
}


/**
 * パスカルケースへ変換 SampleString
 * @param string
 * @return string
 */
export function toPascalCase(str){
  var camel = toCamelCase(str);
  return camel.charAt(0).toUpperCase() + camel.slice(1);
}


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/utility/string.js